import { useEffect } from "react"
import { useMap } from "react-leaflet"
import L from "leaflet"

const ZoomToFeature = ({ feature, zoomLevel }) => {
  const map = useMap()

  useEffect(() => {
    if (feature) {
      const layer = L.geoJSON(feature)
      const bounds = layer.getBounds()
      map.flyToBounds(bounds, {
        padding: [10, 10],
        duration: 1.5,
        easeLinearity: 0.5,
      })
    }
  }, [feature, map, zoomLevel])

  return null
}

export default ZoomToFeature